<template>
	<div class="button-group">
		<GroupIconButton :iconProp="'file'" :urlProp="'//pdfcrowd.com/url_to_pdf/?use_print_media=1&url=' + encodeURIComponent(customUrlProp) + '&pdf_name=Zehnder-configurator&width=210mm&height=297mm&hmargin=10mm&vmargin=10mm'" :labelProp="'Save my selection'" :colourProp="'purple'" />
		<!-- <GroupButton :urlProp="'https://pdfmyurl.com/api?license=NeXGuz5wJb4T&page_size=A4&orientation=portrait&css_media_type=print&javascript_time=2000&filename=Zehnder-configurator&url=' + customUrlProp" :labelProp="'Save my selection'" :colourProp="'purple'" /> -->
		<GroupIconButton :iconProp="'heart'" :urlProp="'/index.php?p=actions/wishlist/items/add&elementId=' + elementIdProp + '&fields[config]=' + configProp.replace(/^#/, '') + '&fields[wishlistFinishId]=' + finishIdProp + '&fields[wishlistValveId]=' + valveIdProp + '&fields[wishlistSupplementalHeater]=' + suppHeaterProp + '&fields[wishlistView]=' + viewProp + '&fields[wishlistZoom]=' + zoomProp + '&fields[wishlistBackground]=' + backgroundProp + '&options[optionhash]=' + elementIdProp + '.' + finishIdProp + '.' + valveIdProp + '.' + suppHeaterProp" :labelProp="'Add to my favourites'" :colourProp="'hotpink'" />
		<GroupButton :urlProp="'/where-to-buy'" :labelProp="'Where to buy'" :colourProp="'blue'" />
		<GroupButton v-if="dealerAreaLinkProp" :urlProp="dealerAreaLinkProp" :labelProp="'Downloadable assets'" :colourProp="'blue'" />
	</div> <!-- product__row -->
</template>

<script>
import GroupButton from './GroupButton';
import GroupIconButton from './GroupIconButton';

export default {
	props: [
		'customUrlProp',
		'configProp',
		'elementIdProp',
		"finishIdProp",
		"valveIdProp",
		"suppHeaterProp",
		"viewProp",
		"zoomProp",
		"backgroundProp",
		"dealerAreaLinkProp",
	],
	data() {
		return {};
	},
	components: {
		GroupButton,
		GroupIconButton,
	},
};
</script>

<style scoped>
	.button-group {
		display: flex;
		flex-direction: column;
		margin: 3rem 0;
		gap: 3rem;
		align-items: center;
	}

	@media screen and (min-width: 800px) {
		.button-group {
			flex-direction: row;
		}
	}
</style>
